import { render, staticRenderFns } from "./MunchenHowTo.vue?vue&type=template&id=387bf252&"
import script from "./MunchenHowTo.vue?vue&type=script&lang=js&"
export * from "./MunchenHowTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports